import { type } from 'os';
<template>
  <div>
    <el-dialog
      width="90%"
      :title="TitleForDialog"
      :visible.sync="DialoVisible"
      @close="OnDialogClose"
      @open="OnDIalogOpen"
    >
      <rabbey-table-3
        :data="detailData"
        :columns="detailColumns"
        :actions="detailActions"
        :loading="detailLoading"
        :paginationApi="paginationApi"
      />

      <div slot="footer" class="dialog-footer">
        <el-button @click="OnDialogClose">Cerrar</el-button>
        <!-- <el-button type="primary" @click="DialoVisible = true">open the inner Dialog</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { COLUMNAS } from "@/views/modules/technical_support/requests/requests";

const actualYear = new Date().getFullYear();

export default {
  name: "MonthlyRequestsByProductsReportDetail",
  props: {
    DialoVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    YearSelected: {
      type: Number,
      default: actualYear
    },
    ThecnicianSelected: {
      type: [Number, null]
    },
    Month: {
      type: [Number, null]
    },
    ProductId: {
      type: [Number, null]
    },
    ProductName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      detailData: [],
      detailColumns: COLUMNAS,
      detailActions: [],
      detailLoading: false,
      paginationApi: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      months: {
        1: { en: "January", es: "Enero" },
        2: { en: "February", es: "Febrero" },
        3: { en: "March", es: "Marzo" },
        4: { en: "April", es: "Abril" },
        5: { en: "May", es: "Mayo" },
        6: { en: "June", es: "Junio" },
        7: { en: "July", es: "Julio" },
        8: { en: "August", es: "Agosto" },
        9: { en: "September", es: "Septiembre" },
        10: { en: "October", es: "Octubre" },
        11: { en: "November", es: "Noviembre" },
        12: { en: "December", es: "Diciembre" }
      }
    };
  },
  computed: {
    TitleForDialog() {
      let title = `Solicitudes de ${this.ProductName} del mes de ${
        this.months[this.Month].es
      }`;
      return title;
    }
  },
  // async mounted() {
  //   await this.GetDetailData();
  // },
  methods: {
    OnDialogClose() {
      this.$emit("ClosingDialog", false);
    },
    async OnDIalogOpen() {
      await this.GetDetailData();
    },
    async GetDetailData() {
      this.detailLoading = true;

      await this.$http
        .get(
          "api/serviceRequests/GetPagedServiceRequestsByProductAndMonthAsync",
          {
            params: {
              Id: null,
              ClientCode: null,
              companyCode: "VF",
              Status: null,
              ProductId: this.ProductId,
              month: this.Month,
              year: this.YearSelected,
              responsibleId: this.ThecnicianSelected
            }
          }
        )
        .then((resp) => {
          this.detailData = resp.data.Items;
          this.paginationApi.currentPage = resp.data.CurrentPage;
          this.paginationApi.total = resp.data.ItemCount;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.detailLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
